import * as React from "react";

function VCVancouver(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.98 6.91L11.25.135c-.174-.172-.37-.186-.544-.014L.998 6.91v11.998c0 .73.551 1.054 1.288 1.054h3.93a.433.433 0 00.433-.436v-3.979h8.712v4.021a.44.44 0 00.435.434h3.827c.736 0 1.354-.604 1.354-1.312 0 0 .044-9.397.003-11.78z"
        fill="currentColor"
      />
      <path
        d="M18.684 18.545h-1.91v-3.769c-.088-.45-.739-.604-.96-.604H6.187c-.274-.019-.84.23-.929.638v3.733H3.32c-.47.001-.804-.339-.804-.548V7.693c.075-.117 8.496-5.704 8.496-5.704l8.496 5.704v10.304c-.003.393-.37.548-.823.548z"
        fill="#fff"
      />
      <path
        d="M5.334 7.186h.924c.1 0 .181.024.243.073.062.05.11.11.141.188l1.45 3.757c.047.123.093.257.137.403.044.146.086.3.126.461.065-.325.146-.614.243-.864l1.444-3.757a.444.444 0 01.136-.179.367.367 0 01.243-.08h.925l-2.489 6.16H7.822L5.334 7.186z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8 13.348h.886l-2.423-6.16h-1.172l-2.419 6.16h.89a.375.375 0 00.244-.08.392.392 0 00.135-.18l.463-1.257h2.551l.461 1.257a.408.408 0 00.14.186.372.372 0 00.243.074zm-1.138-2.326h-1.965l.753-2.04c.035-.095.072-.204.111-.329l.117-.405a7.152 7.152 0 00.234.724l.75 2.05z"
        fill="currentColor"
      />
    </svg>
  );
}

export default VCVancouver;